const professionalExperience = [
  { 
    companyIcon: 'virtual_planet.png', 
    role: 'Unity Programmer', 
    companyName: 'Virtual Planet Technologies LLC ', 
    companyLocation: 'California, United States', 
    year: 'August 2023 - Present'
  },
  { 
    companyIcon: 'ludus_studios.png', 
    role: 'Unity Programmer', 
    companyName: 'Ludus Studios ', 
    companyLocation: 'Pará, Brazil', 
    year: 'March 2023 - May 2023'
  },
  { 
    companyIcon: 'brais_games.png', 
    role: 'Unity Game Developer', 
    companyName: 'Brais Games ', 
    companyLocation: 'Paraíba, Brazil', 
    year: 'February 2021 - February 2023'
  },
];
  
export default professionalExperience;